import { agendaOriginOperationId, agendaUuid, type LocalAgendaActionPrefill } from "@/lib/agendaExecutor";
import { dateAfter, type CalendarActionPrefill } from "@/lib/calendarAction";

/** A destination choice keeps the reviewed event; it never copies remote provenance. */
export async function localDraftForCalendarCreate(prefill: CalendarActionPrefill, assertCurrent: () => void = () => {}): Promise<LocalAgendaActionPrefill | undefined> {
  const owner = prefill.expected_user_id, session = prefill.expected_session_id;
  if (prefill.action !== "create" || !agendaUuid(owner) || !agendaUuid(session)) return undefined;
  const [operation_id, event_id] = await Promise.all([
    agendaOriginOperationId(owner, session, prefill.action_id, "operation", assertCurrent),
    agendaOriginOperationId(owner, session, prefill.action_id, "event:0", assertCurrent),
  ]);
  assertCurrent();
  const allDayStart = prefill.all_day ? dateAfter(prefill.start ?? "", 0) : null;
  const allDayEnd = prefill.all_day ? dateAfter(prefill.end ?? "", 0) : null;
  return { action: "create", action_id: prefill.action_id, operation_id, event_id,
    expected_user_id: owner, expected_session_id: session, source: "mirror", tag: "Personal",
    title: prefill.title, start_at: allDayStart ? allDayStart + "T00:00:00.000Z" : prefill.start,
    end_at: allDayEnd ? allDayEnd + "T00:00:00.000Z" : prefill.end,
    all_day_start: allDayStart, all_day_end: allDayEnd,
    location: prefill.location ?? null, notes: prefill.description ?? null, reminders: [] };
}
